import { useContainer } from "#imports";
import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import type ContactMapper from "~~/package/mapper/contact/ContactMapper";
import {ContactModel} from "~~/package/mapper/contact/model/ContactModel";

export const useContactService = () => {
    const contactMapper = useContainer<ContactMapper>(DependencyInjectId.ContactMapper);

    const submitContactData = (request: ContactModel): Promise<boolean> => {
        return contactMapper.submitContactData(request);
    }

    return {
        submitContactData
    };
};
